import ForgotPassword from '@map/components/GuestArea/Authentication/ForgotPassword';
import Login from '@map/components/GuestArea/Authentication/Login';
import Registration from '@map/components/GuestArea/Authentication/Registration';
import { useCurrentUser } from '@map/hooks/userApi';
import { makeStyles } from '@skill-survey/theme';
import PageSlide from '@ui/PageSlide';
import SlideRoutes from '@ui/mobile/SlideRoutes';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { rootLinks } from '../app/links';
import Navigation from './Navigation';
import { guestLinks } from './links';

const useStyles = makeStyles(() => ({
  authentication: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const Authentication = () => {
  const { classes } = useStyles();
  const location = useLocation();
  const user = useCurrentUser();

  return (
    <PageSlide direction="up">
      <div className={classes.authentication}>
        <Navigation />
        <SlideRoutes location={location}>
          <Route
            exact
            path={guestLinks.authentication()}
            render={() => (!!user.id ? <Redirect to={rootLinks.inner()} /> : <Login />)}
          />
          <Route path={guestLinks.forgotPassword()} component={ForgotPassword} />
          <Route
            path={guestLinks.register()}
            render={() => (!!user.id ? <Redirect to={rootLinks.inner()} /> : <Registration />)}
          />
        </SlideRoutes>
      </div>
    </PageSlide>
  );
};

export default Authentication;
